<ng-container *transloco="let t" class="container">
    <form [formGroup]="inputForm">
        <div class="modal-body">
            <div class="d-flex align-items-center pb-4">
                <img src="assets/img/svg/T.svg" alt="Tracey logo">
                <div class="d-flex align-items-start flex-grow-1">
                    <div class="fw-semibold title-wrapper line-height-1">
                        {{ title ? t(title) : "" }}
                    </div>
                </div>
                <div class="pe-20 d-flex">
                    <button type="button" class="btn-close" aria-label="Close"
                            (click)="activeModal.dismiss('Cross click')"></button>
                </div>
            </div>
            <div class="body-wrapper">
                <table class="w-100 mb-4">
                    <thead class="admin-modal-table-underline">
                    <tr>
                        <th>{{ t('competitor.table.startNumber') }}</th>
                        <th>{{ t('app.common.name.surname') }}</th>
                    </tr>
                    </thead>
                    <tr app-table-header-separator></tr>
                    <tbody>
                    <tr class="admin-modal-table-underline">
                        <td class="center-align fw-semibold py-6">
                            {{ competitor?.startNumber ?? '-' }}
                        </td>
                        <td class="center-align py-6">
                            {{ (competitor?.firstName ?? '') + ' ' + (competitor?.lastName ?? '') }}
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table class="w-100 mt-4">
                    <thead class="admin-modal-table-underline">
                    <tr>
                        <th class="py-6">{{ t('measurements.race.name') }}</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tr app-table-header-separator></tr>
                    <tbody>
                    @for (race of races; track race; let idx = $index) {
                    <tr class="admin-modal-table-underline" [class.disabled]="race.id === competitor?.raceId">
                      <td class="center-align py-6">
                           <app-language-output [hrLabel]="race.name"
                                         [enLabel]="race.nameEng"
                                         [itLabel]="race.nameIta"
                                         [siLabel]="race.nameSlo"
                                         [srLabel]="race.nameSr"
                                         [bsLabel]="race.nameBs"
                                         [languages]="languages"/>
                    </td>

                    <td class="center-align py-6">
                       <div class="d-flex justify-content-center align-items-center">
                           <input type="radio" class="form-check-input" name="selected" [value]="race.id" formControlName="selected" [disabled]="race.id === competitor?.raceId">
                      </div>
                    </td>
                  </tr>
                    }
                    </tbody>
                </table>
                <div class="background-white pt-4 d-flex align-items-center flex-column">
                    <div class="min-width-275 pb-2">
                        @if (raceSettings?.blockStart) {
                            <div class="pt-20-10">
                                <app-input formControlName="startBlock" label="competitor.table.startBlock" [hideErrorMessage]="!!this.errorCode" type="number"></app-input>
                            </div>
                            @if (errorCode && inputForm.controls['startBlock'].errors) {
                                <div class="d-flex align-items-start">
                                    <span class="errorMes">{{t("competitor.edit.error." + errorCode)}}</span>
                                </div>
                            }
                        }
                        <div>
                            <app-input formControlName="startNumber" label="competitor.table.start.number" [hideErrorMessage]="!!this.errorCode"></app-input>
                        </div>
                        @if (errorCode && inputForm.controls['startNumber'].errors) {
                        <div class="d-flex align-items-start">
                            <span class="errorMes">{{t("competitor.edit.error." + errorCode)}}</span>
                        </div>
                        }
                    </div>

                </div>
            </div>

            <div class="d-flex justify-content-center align-items-center pb-40-48">
                <div class="d-flex">
                    <div class="pe-3">
                        <app-rounded-button [label]="t('app.common.cancel')"
                                            [btnClass]="'btn-grey text-uppercase'" (onClick)="onDismissClick()"/>
                    </div>
                    <app-rounded-button [label]="confirmButtonTitle ?? t('app.common.confirm')" (onClick)="onConfirmClick()"
                                        [btnClass]="'btn-primary-red text-uppercase'" [isDisabled]="inputForm.controls.selected.value === competitor?.raceId"></app-rounded-button>
                </div>
            </div>
        </div>
    </form>
</ng-container>
